import { VFC } from 'react'
import { ProfileCard } from 'src/components/UserCard'
import { DISPLAY_TYPE } from 'src/models/Promotion'
import { RecommendedUser } from 'src/models/User'
import { _profilegreen, lightgray, truewhite } from 'src/styles/colors'
import { css } from 'styled-components'
import { ShowReasonModalMeta } from '../RequestReasonModal'
import { PrDetailCard, PrDetailCardProps } from './PrDetailCard'

export const getActions = (
  user: Pick<RecommendedUser, 'matchingStatus' | 'roomUrl' | 'promotion'>,
  postNotInterested: () => unknown,
  showReasonModal: (
    postInterested: ShowReasonModalMeta['postInterested'],
  ) => unknown,
): PrDetailCardProps['actions'] => {
  const { matchingStatus, roomUrl } = user

  return roomUrl
    ? [
        {
          label: 'ルームを見に行く',
          onClick: () => window.open(roomUrl, '_blank'),
          styles: interestedButtonStyle,
        },
      ]
    : [
        {
          label: '興味なし',
          onClick: postNotInterested,
          styles: notInterestedButtonStyle,
          hidden:
            matchingStatus === 'request' ||
            matchingStatus === 'matched' ||
            matchingStatus === 'sended' ||
            matchingStatus === 'matching',
          disabled:
            matchingStatus === 'not_interest' ||
            matchingStatus === 'be_rejected',
        },
        {
          label: 'つながり申請',
          onClick: showReasonModal,
          styles: interestedButtonStyle,
          hidden:
            matchingStatus != null &&
            matchingStatus !== 'request' &&
            matchingStatus !== 'matching',
          disabled:
            matchingStatus === 'request' || matchingStatus === 'matching',
        },
      ]
}

type RecommendationCardProps = {
  user: RecommendedUser
  showDetail: (userId: number) => unknown
  showReasonModal: () => unknown
  postNotInterested: () => unknown
  displayType?: DISPLAY_TYPE
  prDetail?: string
  showPrDetailModal?: () => void
  showProfileModalWithButton?: () => void
  isDisplayedProfileButton?: true
}

export const RecommendationCardBase: VFC<RecommendationCardProps> = ({
  user,
  showDetail,
  showReasonModal,
  postNotInterested,
  displayType,
  prDetail,
  showPrDetailModal,
  showProfileModalWithButton,
  isDisplayedProfileButton,
}) => {
  const actions = getActions(user, postNotInterested, showReasonModal)

  return (
    <>
      {displayType === 'free_text' ? (
        <PrDetailCard
          prDetail={prDetail || ''}
          actions={actions}
          userId={user.id}
          showProfileModalWithButton={showProfileModalWithButton}
          isDisplayedProfileButton={isDisplayedProfileButton}
        />
      ) : (
        <ProfileCard
          user={user}
          showDetail={showDetail}
          actions={actions}
          showPrDetailModal={showPrDetailModal}
        />
      )}
    </>
  )
}
const interestedButtonStyle = css`
  background-color: ${_profilegreen};
  color: ${truewhite};
`

const notInterestedButtonStyle = css`
  background-color: ${lightgray};
  color: ${truewhite};
`
